export const REFRESH_INVOICES_DATATABLE = "REFRESH_INVOICES_DATATABLE";


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/invoicesActionTypes.js